module.exports = __webpack_public_path__ + "img/singapore-featured-image.7de394e5.jpg";